/** Sessão do chat da Manifest no navegador — ver ChatbotManifest.tsx. */

export const ID_SCRIPT = 'manifest-chat-loader';
export const CHAVE_DONO = 'wms-chat-dono';

/*
 * A SESSÃO DA MANIFEST FICA NO NAVEGADOR, NÃO NO LOGIN.
 *
 * O loader.js grava a sessão do chat no localStorage DESTE site
 * (`manifest-chat-session:<origem>:<time>`) e a devolve à Manifest no próximo
 * carregamento — com ou sem chave. Em 28/10/2026 a cris.bastos, sem Slack
 * ligado, entrou no mesmo navegador depois do Paulo e conversou COMO ele (a
 * execução ficou em nome de paulo.silva na Manifest, com o papel de admin).
 * Por isso o WMS anota de quem é a sessão guardada e apaga tudo da Manifest
 * quando o usuário muda — e no logout.
 */
export function limparChatManifest(): void {
  try {
    for (const chave of Object.keys(localStorage)) {
      if (chave.startsWith('manifest-chat-') || chave === CHAVE_DONO) localStorage.removeItem(chave);
    }
  } catch {
    /* storage bloqueado: a Manifest também não conseguiu guardar nada */
  }
}

/** O chat estava carregado nesta página? (a sessão dele também mora no iframe, em memória) */
export const chatCarregado = (): boolean => Boolean(document.getElementById(ID_SCRIPT));

export function donoGuardado(): string | null {
  try {
    return localStorage.getItem(CHAVE_DONO);
  } catch {
    return null;
  }
}
